import { FC } from 'react';
import { SingleLineCellWrapper } from './Styled';

export const SingleLineCell: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <SingleLineCellWrapper>{children}</SingleLineCellWrapper>
);
